module.exports = __webpack_public_path__ + "static/media/icon_147.6e93adbc.png";